import {createContext,useContext,useEffect,useState} from 'react';
import messages from '../services/messages';
import {useAuth} from '../store/Auth';
import {useLocation} from 'react-router-dom';
const Language=createContext(null);
const symbols={'↗':'up-right','→':'right','←':'left','↑':'right','↓':'right','✓':'checkmark','×':'close','☰':'menu','☀':'sun','☾':'moon','◐':'changetheme','⌕':'search','▦':'four-grid','▣':'one-grid','‹':'chevron-left','›':'chevron-right','◇':'image','▾':'chevron-right','↺':'refresh'};
export function Icon({name,className=''}) {return <span className={'ui-icon '+className} data-icon={name} aria-hidden="true" style={{'--icon-image':`url("/assets/Icons/${name}.png")`}}/>;}
export function LanguageProvider({children}) {
  const {user}=useAuth(),route=useLocation();
  const [publicLanguage,setPublic]=useState(()=>{try{return localStorage.getItem('zirve-public-language')||'tr';}catch{return 'tr';}});
  const language=['/','/index.html','/login.html','/login'].includes(route.pathname)?publicLanguage:user?.language||publicLanguage;
  const t=value=>messages.t(String(value),language);
  const locale={tr:'tr-TR',en:'en-GB',ar:'ar'}[language]||'tr-TR';
  useEffect(()=>{
    document.documentElement.lang=language;document.documentElement.dir=language==='ar'?'rtl':'ltr';
    window.I18n={t,current:language,locale};document.dispatchEvent(new Event('language-changed'));
  },[language]);
  const changePublic=value=>{setPublic(value);try{localStorage.setItem('zirve-public-language',value);}catch{}};
  return <Language.Provider value={{language,t,locale,changePublic}}>{children}</Language.Provider>;
}
export const useText=()=>useContext(Language);
export function viewContent(content,id,bind,keys,fallback) {
  if(Object.hasOwn(content,id))return content[id];
  for(const key of [...keys].reverse())if(Object.hasOwn(bind[key]||{},'children'))return bind[key].children;
  return fallback;
}
export function T({text,children}) {
  const {t}=useText();const source=String(text??children??'');
  if(!source.trim())return source;
  const value=source.match(/^\s*/)[0]+t(source)+source.match(/\s*$/)[0];
  return <>{value.split(/([↗→←↑↓✓×☰☀☾◐⌕▦▣‹›◇▾↺])/u).map((part,index)=>symbols[part]?<Icon key={index} name={symbols[part]} className={['↓','▾'].includes(part)?'rotate-down':part==='↑'?'rotate-up':''}/>:part)}</>;
}
export function LanguageSelect(props) {const {language,changePublic}=useText();return <select {...props} value={language} onChange={e=>changePublic(e.target.value)}><option value="tr">Türkçe</option><option value="en">English</option><option value="ar">العربية</option></select>;}
